// Set the configuration for your app
var config = {
	apiKey: "AIzaSyBqU_MDmTwv5RtyeovGhuz-lpLsKKK3k-4",
	authDomain: "cc-proposal-tool.firebaseapp.com",
	databaseURL: "https://cc-proposal-tool.firebaseio.com",
	projectId: "cc-proposal-tool",
	storageBucket: "cc-proposal-tool.appspot.com",
	messagingSenderId: "359594190366"
};


// Get a reference to the database service
var database = firebase.database();

export default {
	getClients(cb) {
		console.log('get Clients');
		let clients = firebase.database().ref('clients').orderByChild('timestamp');
		clients.on('value', function (snapshot) {
			let client = snapshot.val();
			if (client === null || client === undefined) {
				return
			}
			cb(client);
		});
	},
	createClient(client, cb) {
		console.log('create client');

		let mRef = firebase.database().ref('clients');
		let key = firebase.database().ref('clients').push().key;
		let newClient = firebase.database().ref('clients/' + key);
		
		newClient.set({
			id: key,
			"Client-Name": client['Client-Name'],
			"Contact-Person": client['Contact-Person'],
			"Street": client['Street'],
			"Place": client['Place'],
		});
		
		newClient.once('value', function (snapshot) {
			let client = snapshot.val();
			if (client === null || client === undefined) {
				return
			}
			cb(client);
		});
	},
	updateClient(clientInfo, cb) {
		console.log('update client');

		let clients = firebase.database().ref('clients');
		let client = clients.child(clientInfo.id);
		
		client.update({
			id: clientInfo.id,
			"Client-Name": clientInfo['Client-Name'],
			"Contact-Person": clientInfo['Contact-Person'],
			"Street": clientInfo['Street'],
			"Place": clientInfo['Place'],
		});
	},
}



// WEBPACK FOOTER //
// ./src/api/clients.js